import { put, select, takeLatest } from 'redux-saga/effects'
import { getAirwaySelector } from '../selectors'
import { setAirTemperatureUnitTemp } from '../store/airway.actions'
import { AirwayConstants } from '../store/airway.constants'
import { IAirwayState } from '../store/airway.types'

export function* setAirwayTemperatureUnit() {
  const airwayState: IAirwayState = yield select(getAirwaySelector)
  const { airTemperatureBool } = airwayState
  let data = null
  if (airTemperatureBool) {
    data = { id: 'f', name: 'F' }
  } else {
    data = { id: 'c', name: 'C' }
  }
  yield put(setAirTemperatureUnitTemp(data))
}

export function* setAirwayTemperatureUnitSaga() {
  yield takeLatest([AirwayConstants.SET_AIR_TEMPERATURE_UNIT], setAirwayTemperatureUnit)
}
